<template>

    <div class="main-login-wrapper">

        <div class="notification" v-bind:class="{ error: notificationIsError, info: !notificationIsError }" v-if="hasNotification">
            {{ $t(`${errorMessage}`) }}
        </div>

        <div class="wrapper">

            <div class="container" v-bind:class="{ shake: notificationIsError }">

                <div class="logo">
                    <img src="@/assets/images/logo.png" alt="logo" />
                </div>

            </div>

        </div>

        <div class="footer">
            <p v-html="copyright"></p>
            <p>{{ version }}</p>
        </div>

    </div>

</template>

<style lang="scss" scoped>
@import '@/assets/scss/base.scss';

.main-login-wrapper
{
    position: absolute;

    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    background: linear-gradient(135deg, $fs-blue-color 0%, $fs-orange-color 100%);
}

.notification
{
    position: fixed;

    top: 0;

    margin: 0;
    padding: 8px;

    width: 100%;

    text-align: center;

    &.error
    {
        background: $red;
        color: white;
    }

    &.info
    {
        background: $blue;
        color: white;
    }
}

.wrapper
{
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;

    align-items: center;
    justify-content: center;

    height: 100%;

    .container
    {
        display: block;
        box-sizing: border-box;

        margin: 0;
        padding: 24px;

        width: 480px;
        min-width: 240px;

        border-radius: 12px;

        background: transparent;

        .logo
        {
            text-align: center;
        }

        .row
        {
            margin: 0px -8px;
            width: auto;

            &:before, &:after
            {
                content: " ";
                display: table;

                clear: both;
                box-sizing: border-box;
            }

            .column-100
            {
                position: relative;
                width: 100%;

                padding: 0px 8px;
                box-sizing: border-box;
            }
        }

        .width-100
        {
            width: 100%;
        }

        label
        {
            position: relative;

            .placeholder-icon
            {
                position: absolute;

                top: 0;
                left: 0;

                z-index: 2;

                padding: 10px;
                color: $light;
            }

            input[type="text"], input[type="password"]
            {
                width: 100%;

                margin-bottom: 8px;
                padding-left: 32px;
            }
        }

        .button
        {
            text-align: center;

            &.loading
            {
                background: $light;
                opacity: 0.4;
            }
        }
    }

    .shake
    {
        animation: shake 0.75s;
    }

    .disabled
    {
        opacity: 0.5;
        pointer-events: none;
    }

    .actions
    {
        margin: 0;
        padding: 12px;

        width: 480px;
        min-width: 240px;

        font-size: 12px;
        color: $normal;

        text-align: center;
    }
}

.footer
{
    position: fixed;
    bottom: 0;

    margin: 0;
    padding: 8px;

    width: 100%;

    font-size: 12px;
    color: $white;

    text-align: center;
}

@keyframes shake
{
    0%, 100% {transform: translateX(0);}
    10%, 30%, 50%, 70%, 90% {transform: translateX(-10px);}
    20%, 40%, 60%, 80% {transform: translateX(10px);}
}
</style>

<script>
import { appVersion } from '@/assets/js/config';

export default {
    name: 'Authentication', // eslint-disable-line vue/multi-word-component-names
    data: () =>
    {
        return {
            hasNotification: false,
            notificationIsError: false,
            errorMessage: 'ERROR',
            state: 'LOGIN',
            copyright: '&copy; Most Wanted Software ' + '2015 - ' + new Date().getFullYear(),
            version: 'v' + appVersion,
        };
    },
};
</script>
